export enum LocalStorageKey {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  SIDEBAR_COLLAPSE_TOGGLE = 'sidebar_collapse_toggle',
}
